import axios from "axios";
import { Action } from "./actionsShared";
import { server } from "./backend-url";

export const FETCH_USER_ALERTS_PREFIX = "FETCH_USER_ALERTS";
export const FETCH_USER_ALERTS_SETTINGS_PREFIX = "FETCH_USER_ALERT_SETTINGS";

export const fetchUserAlerts = () => {
  const url = "/api/alerts";
  return Action.GET(FETCH_USER_ALERTS_PREFIX, url, true);
};

export const fetchUserAlertSettings = () => {
  const url = "/api/alerts/settings";
  return Action.GET(FETCH_USER_ALERTS_SETTINGS_PREFIX, url, true);
};

export const updateUserAlert = async (alertId, alertStatus) => {
  const authToken = localStorage.getItem('AuthToken');
  axios.defaults.headers.common = { Authorization: `${authToken}` };
  try {
    await axios.put(`${server}/api/alerts/statusUpdate/${alertId}`, { status: alertStatus });
  } catch (e) {
    console.error(e);
  }
}

export const updateUserAlertsSettings = async (settings, groupSettings) => {
  const authToken = localStorage.getItem('AuthToken');
  axios.defaults.headers.common = { Authorization: `${authToken}` };
  try {
    await axios.put(`${server}/api/alerts/settings`, { settings, groupSettings });
  } catch (e) {
    console.error(e);
  }
}

export const resolveAllUserAlerts = async () => {
  const authToken = localStorage.getItem('AuthToken');
  axios.defaults.headers.common = { Authorization: `${authToken}` };
  try {
    await axios.delete(`${server}/api/alerts/all`);
  } catch (e) {
    console.error(e);
  }
}

export const acknowledgeAllUserAlerts = async () => {
  const authToken = localStorage.getItem('AuthToken');
  axios.defaults.headers.common = { Authorization: `${authToken}` };
  try {
    await axios.put(`${server}/api/alerts/all`);
  } catch (e) {
    console.error(e);
  }
}